import { faFacebookF, faYoutube, faInstagram } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const currentYear = new Date().getFullYear();

function Footer({ style }) {
    return (
        <footer className={`footer ${style ? 'dark-mode' : ""}`}>
            
            <Container>
                <Row className="justify-content-between">
                    <Col lg={4} md={6} className="mb-4">
                        <div className="footer-section">
                            <div className="footer-logo">
                                <img src="/images/logo-light.png" alt="د/ إيمان عمران"/>
                            </div>
                            <p className="footer-description">
                                منصة تعليمية متخصصة في <span> intgrated science  </span>    تحت إشراف  د/ إيمان عمران  
                            </p>
                        </div>
                    </Col>
                    
                    <Col lg={8} md={6} className="mb-4">
                        <div className="footer-section">
                            <h5>تواصل معنا</h5>
                            <div className="social-links">
                                <a href="#" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="يوتيوب">
                                    <FontAwesomeIcon icon={faYoutube} />
                                </a>
                                <a href="#" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="فيسبوك">
                                    <FontAwesomeIcon icon={faFacebookF} />
                                </a>
                                <a href="#" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="انستغرام">
                                    <FontAwesomeIcon icon={faInstagram} />
                                </a>
                            </div>
                        </div>
                    </Col>
                </Row>
                
                <div className="footer-bottom">
                <div className="powered-by">
                        <span>Powered by </span>
                        <Link to="https://www.facebook.com/profile.php?id=61556333871338" target="_blank" rel="noopener noreferrer">ReachX</Link>
                    </div>
                    <div className="copyright">
                        <span>Developed by</span> 
                        <Link to="https://www.facebook.com/said.sayed.3386" target="_blank">Said</Link> , 
                        <Link to="https://www.facebook.com/ahmed.abdelhamidnassef" target="_blank">Nassef</Link> 
                        <span>All Copy Rights Reserved © {currentYear}</span>
                    </div>
                </div>
            </Container>
        </footer>
    );
}

export default Footer;